<template>
    <div class="page">
        <v-container :class="{'px-0': phoneOnly}">
            <!-- <h1 class="mb-2">childs</h1>
            <p>Hello, welcome to Riwaq Al Quran Portal</p> -->

            <v-alert v-if="parentSession" type="info" color="blue-grey" text class="d-flex align-center">
                <div class="d-sm-flex align-center justify-space-between">
                    <span>You are in {{ user ? user.name : '' }}'s account.</span>
                    <v-btn small depressed color="blue-grey" dark class="mt-2 mt-sm-0 ms-sm-4" style="text-transform: none" :loading="switchingTo === parentSession.id" :disabled="!!switchingTo" @click="switchBack">
                        <v-icon left small>mdi-arrow-u-left-top</v-icon>
                        Back to {{ parentSession.name }}
                    </v-btn>
                </div>
            </v-alert>

            <v-card :flat="phoneOnly" class="px-1 px-lg-3" :class="{'transparent': phoneOnly, 'soft-shadow': pcOnly}">
                <v-card-title class="d-flex justify-space-between">
                    <div>
                        Family Accounts
                    </div>
                    <div v-if="!capRunning && canManageFamily" class="px-3">
                        <v-btn color="success" depressed @click="newChildDialog = true; hideRegisterForm = false">
                            <v-icon size="20" left>mdi-account-plus</v-icon>
                            New Account
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-subtitle v-if="canManageFamily">You can create accounts for your family and transfer money to their wallets</v-card-subtitle>
                <v-card-subtitle v-else>Your family accounts. Switch to any of them without signing in again.</v-card-subtitle>
                <v-card-text v-if="!loading">
                    <v-simple-table v-if="childs && childs.length">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Name
                                    </th>
                                    <th class="text-left">
                                        Role
                                    </th>
                                    <th class="text-left">
                                        Email
                                    </th>
                                    <th class="text-left">
                                        Balance
                                    </th>
                                    <th class="text-left">
                                        Borrowed Balance
                                    </th>
                                    <th class="text-right">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="child in childs" :key="child.id">
                                    <td class="font-weight-bold">{{child.name}}</td>
                                    <td>
                                        <v-chip small :color="child.role === 'parent' ? 'deep-purple lighten-5' : 'blue lighten-5'" :class="child.role === 'parent' ? 'deep-purple--text text--darken-2' : 'blue--text text--darken-3'">
                                            {{ child.role === 'parent' ? 'Parent' : 'Child' }}
                                        </v-chip>
                                    </td>
                                    <td>{{child.email}}</td>
                                    <td>
                                        <v-icon size="22" :color="child.credits < 2 ? 'red' : 'orange darken-2'">mdi-wallet</v-icon>
                                        <span class="font-weight-bold ms-2" :class="{'error--text': child.credits < 2}">{{moneyFormat(child.credits)}}</span>
                                    </td>
                                    <td>
                                        <span class="font-weight-medium" :class="{'error--text': child.loan_credits > 0}">{{moneyFormat(child.loan_credits)}}</span>
                                    </td>
                                    <td class="text-right" style="white-space: nowrap;">
                                        <v-btn v-if="canSwitchTo(child)" color="teal darken-2" depressed small dark style="text-transform: none" :loading="switchingTo === child.id" :disabled="!!switchingTo" @click="switchTo(child)">
                                            <v-icon left small>mdi-account-switch</v-icon>
                                            Switch
                                        </v-btn>
                                        <v-btn v-if="canManageFamily" class="ms-2" color="blue darken-2" depressed small dark style="text-transform: none" @click="transferDialog = true; transferToChild = child.id;">
                                            <v-icon left small>mdi-wallet-plus</v-icon>
                                            Transfer
                                        </v-btn>
                                        <v-btn v-if="canManageFamily" class="ms-2" color="red darken-2" outlined small style="text-transform: none" @click="removeDialog = true; childToRemove = child;">
                                            <v-icon left small>mdi-account-remove</v-icon>
                                            Remove
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <div v-else-if="!loading">
                        <v-alert type="info" color="blue-grey" text>
                            {{ canManageFamily ? 'No family accounts found, add a new account now!' : 'Nobody else is in your family right now.' }}
                        </v-alert>
                    </div>
                </v-card-text>
            </v-card>

            <v-btn v-if="canManageFamily" color="primary" fab fixed bottom right @click="newChildDialog = true; hideRegisterForm = false" style="bottom: 80px;">
                <v-icon size="26">mdi-account-plus</v-icon>
            </v-btn>
        </v-container>

        <v-dialog v-model="transferDialog" max-width="350">
            <v-card>
                <v-card-title class="mb-2">Transfer Credits</v-card-title>
                <v-card-subtitle>transfer credits directly from your wallet to family member's wallet</v-card-subtitle>
                <v-card-text class="py-5">
                    <v-text-field v-model="transferAmount" autofocus :loading="transferring" :disabled="transferring" color="orange" hide-details class="transfer-input font-weight-medium" type="number" outlined label="Amount" placeholder="Enter Amount" suffix="$" min="1"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="transferring" @click="transferDialog = false">Cancel</v-btn>
                    <v-btn :loading="transferring" :disabled="transferring" text color="success" @click="transferAction">Transfer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="removeDialog" max-width="400" :persistent="removing">
            <v-card>
                <v-card-title class="mb-2">Remove from family</v-card-title>
                <v-card-subtitle>
                    {{ childToRemove ? childToRemove.name : '' }} will no longer show in your family accounts, and you will not be able to transfer credits to them.
                    <br><br>
                    Their student account stays open. Classes, progress and balance are not touched.
                </v-card-subtitle>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="removing" @click="removeDialog = false">Cancel</v-btn>
                    <v-btn :loading="removing" :disabled="removing" text color="error" @click="removeAction">Remove</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="newChildDialog" max-width="600" persistent :fullscreen="capRunning" scrollable>
            <v-card :style="`${iosSafeArea ? 'padding-top: 45px!important; ' : ''}`">
                <v-card-title>New Family Account</v-card-title>
                <v-card-text class="py-5">
                    <register-form v-if="!hideRegisterForm" button-text="Create Account" :loading="creating" :dialog-opened="newChildDialog" :initial="childFormDefaults" allow-generate-email require-profile :email-error.sync="createEmailError" @register="addNewChild" />
                </v-card-text>
                <v-btn icon absolute top right @click="newChildDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <!-- <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="creating" @click="newChildDialog = false">Cancel</v-btn>
                    <v-btn :loading="creating" :disabled="creating" text color="success" @click="addNewChild">Confirm</v-btn>
                </v-card-actions> -->
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import RegisterForm from '@/components/custom/register-form'
import FamilySession from '@/helpers/family-session'

export default {
    name: "childs",
    components: {
        RegisterForm
    },
    data(){
        return {
            searchQuery: '',
            loading: false,

            newChildDialog: false,
            hideRegisterForm: false,
            creating: false,
            createEmailError: '',

            switchingTo: null,

            transferDialog: false,
            transferToChild: null,
            transferAmount: '',
            transferring: false,

            removeDialog: false,
            childToRemove: null,
            removing: false,
        }
    },
    computed: {
        childs(){
            return this.$store.state.childsModule.childs;
        },
        visiblechilds(){
            const query = this.searchQuery.toLowerCase();
            let childs = this.childs;

            if (query){
                return childs.filter(child=>child.name.toLowerCase().search(query) !== -1)
            }

            return childs;
        },
        // a member of someone else's family cannot open accounts of their own,
        // send credits, or unlink anybody
        canManageFamily(){
            return !(this.user && this.user.has_parents);
        },
        // the parent who signed in on this device, when we are not them
        parentSession(){
            const parent = FamilySession.get();
            return (parent && this.user && parent.id !== this.user.id) ? parent : null;
        },
        // contact details a new child inherits, so nobody retypes them
        childFormDefaults(){
            if (!this.user) return {};

            return {
                // the number as the parent typed it, so the country selector
                // stays on their country. A dial code here would be read back
                // as whichever country claims it first, and +44 alone cannot
                // tell the UK from Guernsey.
                phone: this.user.phone || '',
                phone_country: this.user.phone_country || '',
                preferred_channel: this.user.preferred_channel || '',
            };
        },
        ...GlobalComputed
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        // a child row can be taken over through the API. The parent row is
        // only reachable with the token this device saved at their sign in.
        canSwitchTo(member){
            if (member.role === 'parent'){
                return !!(this.parentSession && this.parentSession.id === member.id);
            }
            return !!member.can_switch;
        },
        goHome(){
            // full page load so the app rebuilds itself around the new token
            window.location.href = window.location.origin + '/home';
        },
        switchTo(member){
            if (this.switchingTo) return;

            if (member.role === 'parent'){
                this.switchBack();
                return;
            }

            this.switchingTo = member.id;
            this.$store.dispatch('switchFamilyAccount', {id: member.id}).then(()=>{
                this.goHome();
            }).catch(e=>{
                this.switchingTo = null;

                if (e.response && e.response.data === 'SUSPENDED_ACCOUNT'){
                    this.showMsg('That account is suspended', 'error');
                }else if (e.response && e.response.status === 403){
                    this.showMsg('You cannot switch to that account', 'error');
                }else{
                    this.showMsg('Error occurred during preforming the action', 'error');
                }
            })
        },
        switchBack(){
            if (this.switchingTo || !this.parentSession) return;

            this.switchingTo = this.parentSession.id;
            this.$store.dispatch('switchBackToParent').then(done=>{
                if (done){
                    this.goHome();
                }else{
                    this.switchingTo = null;
                    this.showMsg('Sign in again to get back to that account', 'error');
                }
            })
        },
        addNewChild(data){
            if (!this.creating){
                this.creating = true;
                this.createEmailError = '';
                this.$store.dispatch('newChild', data).then(()=>{
                    this.creating = false;
                    this.newChildDialog = false;
                    window.setTimeout(()=>{
                        this.hideRegisterForm = true; // this will destroy register-form component to reset form
                    }, 600);
                    this.showMsg('Account created successfully', 'success');

                }).catch(e=>{
                    this.creating = false;

                    const errors = e.response && e.response.data && e.response.data.errors;
                    if (errors && errors.email){
                        this.createEmailError = errors.email[0];
                        this.showMsg(errors.email[0], 'error');
                    }else if (e.response && e.response.status === 403){
                        this.showMsg('Only the parent account can create family accounts', 'error');
                    }else{
                        this.showMsg('Error occurred during preforming the action', 'error');
                    }
                })
            }
        },
        transferAction(){
            if (this.transferAmount){
                if (!this.transferring){
                    this.transferring = true;
                    this.$store.dispatch('transferCreditsToChild', {child_id: this.transferToChild, amount: this.transferAmount}).then(()=>{
                        this.transferring = false;
                        this.transferDialog = false;
                        this.transferAmount = '';
                        this.showMsg('Credits transferred successfully', 'success');
                    }).catch(e=>{
                        this.transferring = false;

                        if (e.response && e.response.data === 'NO_ENOUGH_CREDITS'){
                            this.showMsg('No Enough Credits', 'error');
                        }else if (e.response && e.response.data && e.response.data.message){
                            // Display the dynamic message from backend
                            this.showMsg(e.response.data.message, 'error');
                        }else{
                            this.showMsg('Error occurred during preforming the action', 'error');
                        }
                    })
                }
            }
        },
        removeAction(){
            if (this.childToRemove && !this.removing){
                this.removing = true;
                this.$store.dispatch('removeChild', {id: this.childToRemove.id}).then(()=>{
                    this.removing = false;
                    this.removeDialog = false;
                    this.childToRemove = null;
                    this.showMsg('Removed from your family accounts', 'success');
                }).catch(e=>{
                    this.removing = false;

                    if (e.response && e.response.data === 'CHILD_NOT_FOUND'){
                        this.showMsg('This account is not in your family accounts', 'error');
                    }else{
                        this.showMsg('Error occurred during preforming the action', 'error');
                    }
                })
            }
        },
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('loadChilds').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    this.loading = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        ...GlobalMethods
    },
    mounted(){
        if (this.appData && !this.appData.enable_app_w){
            this.$router.push('/not-found');
        }else{
            if (!this.childs || this.childs.length === 0){
                this.loadData();
            }
        }
    }
};
</script>
